import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import HeaderSection from '../../components/home/HeaderSection';
import { ROUTES } from '../../constants/routes';
import { useAuthContext } from '../../context/AuthContext';
import { useProfileContext } from '../../context/ProfileContext';
import { getProfilePhotoUrl, mapProfileToForm } from '../../utils/profileMappers';
import ProfileSidebar from './ProfileSidebar';

const SECTION_BY_PATH = {
  [ROUTES.PROFILE]: 'profile',
  [ROUTES.PROFILE_PLAN]: 'plan',
  [ROUTES.PROFILE_PROGRESS]: 'progress',
  [ROUTES.PROFILE_FAVORITES]: 'favorite',
  [ROUTES.PROFILE_HELP]: 'help',
};

export default function ProfileLayout() {
  const { isLoggedIn, openAuthPopup, logout } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading } = useProfileContext();

  const profileForm = user ? mapProfileToForm(user) : null;
  const userName = profileForm?.fullName?.trim() || 'User';
  const userPhone = profileForm?.mobile || '';
  const profilePhoto = getProfilePhotoUrl(user);
  const activeItem = SECTION_BY_PATH[location.pathname] || 'profile';

  useEffect(() => {
    if (!isLoggedIn) {
      openAuthPopup();
      navigate('/', { replace: true });
    }
  }, [isLoggedIn, navigate, openAuthPopup]);

  const handleLogout = () => {
    logout();
    navigate('/', { replace: true });
  };

  const handleNavigate = (sectionId) => {
    if (sectionId === 'profile') navigate(ROUTES.PROFILE);
    if (sectionId === 'plan') navigate(ROUTES.PROFILE_PLAN);
    if (sectionId === 'progress') navigate(ROUTES.PROFILE_PROGRESS);
    if (sectionId === 'favorite') navigate(ROUTES.PROFILE_FAVORITES);
    if (sectionId === 'help') navigate(ROUTES.PROFILE_HELP);
  };

  if (!isLoggedIn) return null;

  return (
    <>
      <HeaderSection />

      <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8 lg:py-8">
        <div className="grid min-w-0 grid-cols-1 gap-6 lg:grid-cols-[280px_minmax(0,1fr)] xl:grid-cols-[300px_minmax(0,1fr)]">
          <ProfileSidebar
            userName={loading && !user ? '...' : userName}
            userPhone={loading && !user ? '' : userPhone}
            avatarUrl={profilePhoto}
            activeItem={activeItem}
            onNavigate={handleNavigate}
            onLogout={handleLogout}
          />

          <div className="min-w-0">
            <Outlet context={{ user, profilePhoto }} />
          </div>
        </div>
      </div>
    </>
  );
}
